import {Component, OnDestroy, OnInit} from '@angular/core';
import {DataTableHeaderCommunicationService} from '@Common/widgets/general/data-table';
import {DepositService} from '../../../services/deposit/deposit.service';
import {HeaderFilterService} from '@Common/widgets/general/data-table/services/header-filter.service';
import {FilterRevisionDepositsData} from './filter-revision-deposits.model';
import {SubSink} from '@Common/core/utils/subsink';

@Component({
  selector: 'app-filter-revision-deposits',
  templateUrl: './filter-revision-deposits.component.html',
  styleUrls: ['./filter-revision-deposits.component.scss', '../filter-deposits.component.scss']
})
export class FilterRevisionDepositsComponent extends HeaderFilterService implements OnInit, OnDestroy {
  searchText = null;
  subSink = new SubSink();
  constructor(public dtCommunicationSvc: DataTableHeaderCommunicationService,
              private depositSvc: DepositService) {
    super(dtCommunicationSvc);
  }

  ngOnInit(): void {
    this.searchText = this.data || '';
  }

  onCancel(event) {
  }

  onValidate(event) {
    const dataEmit = <FilterRevisionDepositsData> {
      nameComponent: this.name,
      action: 'validate',
      value: this.searchText,
      condition: this.searchText ? `sur ${this.searchText}` : ''
    };
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit);
  }

  sendAllReinit(reinit: boolean) {
    this._sendReinit();
  }

  sendReinit(filterName: string) {
    this._sendReinit();
  }
  private _sendReinit() {
    this.searchText = null;
    const dataEmit = <FilterRevisionDepositsData>{nameComponent: this.name, action: 'reinit'};
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit, false);
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
